import { isObject } from 'underscore';

import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';

const simplyEmailRegex = /^[^\s]+@[^\s]+\.[^\s]+$/;

const getEmailFromUnknownRecursive = (data: unknown) => {
  if (isObject(data)) {
    const unknownEmail = data?.email ?? data?.EMAIL;
    return getEmailFromUnknownRecursive(unknownEmail);
  } else if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data);
      return getEmailFromUnknownRecursive(parsed);
    } catch (error) {
      // an invalid parse here likely means we have a real email
      if (typeof data === 'string' && simplyEmailRegex.test(data)) {
        return data;
      } else {
        console.error('Could not parse email', error);
      }
    }
  } else {
    console.error('invalid fireside host email type:', typeof data, data);
  }
};

const getFiresideHostEmailOptions = (firesideHosts?: unknown[]) => {
  const emailWithEmpties = (firesideHosts || []).map((email: unknown) => {
    if (!email) return null;

    const _email = getEmailFromUnknownRecursive(email);

    if (!_email) return null;

    return { label: _email, value: _email, meta: _email };
  });

  return emailWithEmpties.filter(Boolean) as TReactSelectOption<string, string, string>[];
};

export default getFiresideHostEmailOptions;
